"use strict";

exports.__esModule = true;
exports.getWishlistIds = exports.getWishlist = exports.getViewedProducts = exports.getSharedStateAge = exports.getOnboardingResult = exports.getKitchenConfigurationsState = exports.getKitchenConfigurations = void 0;
var _selectors = require("../selectors");
var getKitchenConfigurationsState = exports.getKitchenConfigurationsState = function getKitchenConfigurationsState(state) {
  return state.kitchenConfigurations || [];
};
var getOnboardingResultState = function getOnboardingResultState(state) {
  return state.onboardingResult || {};
};
var getWishlistState = function getWishlistState(state) {
  return state.wishlist || [];
};
var getViewedProductsState = function getViewedProductsState(state) {
  return state.viewedProducts;
};
var getSharedStateAgeState = function getSharedStateAgeState(state) {
  return state.sharedStateAge || {};
};
var getKitchenConfigurations = exports.getKitchenConfigurations = (0, _selectors.createSelector)(getKitchenConfigurationsState, function (config) {
  return config;
});
var getOnboardingResult = exports.getOnboardingResult = (0, _selectors.createSelector)(getOnboardingResultState, function (result) {
  return result;
});
var getWishlist = exports.getWishlist = (0, _selectors.createSelector)(getWishlistState, function (products) {
  return products;
});
var getViewedProducts = exports.getViewedProducts = (0, _selectors.createSelector)(getViewedProductsState, function (products) {
  return products;
});
var getWishlistIds = exports.getWishlistIds = (0, _selectors.createSelector)(getWishlistState, function (products) {
  var ids = products.map(function (p) {
    return p.id;
  });
  return ids;
});
var getSharedStateAge = exports.getSharedStateAge = (0, _selectors.createSelector)(getSharedStateAgeState, function (stateAge) {
  return stateAge;
});